module.exports = {
  HOST: '',
  TABLE_SHRINK_HEIGHT: 0,
  DEFAULT_USER: '',
  DEFAULT_PASSWORD: '',
  VERSION: '04111039',
  VERSION_DATE: '04.11.2026'
}
